"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
// eslint-disable-next-line @typescript-eslint/no-object-literal-type-assertion
const context = React.createContext({});
exports.UserContextProvider = context.Provider;
exports.UserContextConsumer = context.Consumer;
